import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="gradient-bg">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8">
          <Link to="/" className="inline-flex items-center gap-3 group">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-tiki-400 to-tiki-600 flex items-center justify-center">
              <span className="text-white font-bold text-lg">T</span>
            </div>
            <span className="text-white font-bold text-xl tracking-tight">
              Tiki<span className="text-tiki-400">Media</span>
            </span>
          </Link>
        </div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 pb-16 pt-8">
          <h1 className="text-4xl lg:text-5xl font-bold text-white">Terms of Service</h1>
          <p className="text-midnight-300 mt-4">Last updated: January 2025</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 lg:px-8 py-16">
        <div className="prose prose-lg prose-midnight max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-bold text-midnight-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-midnight-600 leading-relaxed">
              By accessing and using the Tiki Media website (tiki-m.com) and our services, you agree to be bound by
              these Terms of Service. If you do not agree with any part of these terms, you should not use our website
              or services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-midnight-900 mb-4">2. Services</h2>
            <p className="text-midnight-600 leading-relaxed">
              Tiki Media provides advertising, business development, online media management, and software development
              services. The specific terms of any engagement will be outlined in separate service agreements between
              Tiki Media and the client.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-midnight-900 mb-4">3. Intellectual Property</h2>
            <p className="text-midnight-600 leading-relaxed">
              All content on this website, including text, graphics, logos, icons, images, and software, is the property
              of Tiki Media or its content suppliers and is protected by international copyright laws. You may not
              reproduce, distribute, modify, or create derivative works from any content without our express written permission.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-midnight-900 mb-4">4. User Conduct</h2>
            <p className="text-midnight-600 leading-relaxed mb-4">When using our website and services, you agree not to:</p>
            <ul className="list-disc list-inside text-midnight-600 space-y-2">
              <li>Use our services for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Transmit any viruses or harmful code</li>
              <li>Interfere with the proper functioning of our website</li>
              <li>Collect or harvest personal data of other users</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-midnight-900 mb-4">5. Limitation of Liability</h2>
            <p className="text-midnight-600 leading-relaxed">
              Tiki Media shall not be liable for any indirect, incidental, special, consequential, or punitive damages
              arising from your use of our website or services. Our total liability for any claims arising from these
              terms shall not exceed the amount you paid to us in the twelve months preceding the claim.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-midnight-900 mb-4">6. Disclaimer of Warranties</h2>
            <p className="text-midnight-600 leading-relaxed">
              Our website and services are provided "as is" and "as available" without warranties of any kind, whether
              express or implied. We do not warrant that our website will be uninterrupted, error-free, or free of
              viruses or other harmful components.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-midnight-900 mb-4">7. Third-Party Links</h2>
            <p className="text-midnight-600 leading-relaxed">
              Our website may contain links to third-party websites. We are not responsible for the content, privacy
              policies, or practices of any third-party sites. We encourage you to review the terms and policies of any
              third-party websites you visit.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-midnight-900 mb-4">8. Modifications</h2>
            <p className="text-midnight-600 leading-relaxed">
              We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately
              upon posting on this page. Your continued use of our website after changes are posted constitutes your
              acceptance of the revised terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-midnight-900 mb-4">9. Governing Law</h2>
            <p className="text-midnight-600 leading-relaxed">
              These Terms of Service shall be governed by and construed in accordance with the laws of Israel, without
              regard to its conflict of law provisions. Any disputes arising from these terms shall be subject to the
              exclusive jurisdiction of the courts in Tel Aviv, Israel.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-midnight-900 mb-4">10. Contact Us</h2>
            <p className="text-midnight-600 leading-relaxed">
              If you have any questions about these Terms of Service, please contact us at:{' '}
              <a href="mailto:contact@tiki-m.com" className="text-tiki-600 hover:text-tiki-700 underline">
                contact@tiki-m.com
              </a>
            </p>
            <p className="text-midnight-600 leading-relaxed mt-2">
              Baal Haakeda 27 A, Tel Aviv-Jaffa, Israel
            </p>
          </section>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-midnight-950 border-t border-midnight-800/50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-tiki-400 to-tiki-600 flex items-center justify-center">
                <span className="text-white font-bold text-xs">T</span>
              </div>
              <span className="text-midnight-400 text-sm">
                &copy; {new Date().getFullYear()} Tiki Media. All rights reserved.
              </span>
            </div>
            <div className="flex items-center gap-6">
              <Link to="/privacy" className="text-sm text-midnight-400 hover:text-tiki-400 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-sm text-midnight-400 hover:text-tiki-400 transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfService;
